import React from 'react';
import { Button, IconButton, Tooltip } from '@mui/material';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';

import { cardButtonSx } from 'theme/buttons';

export const ResumeButton: React.FC<{
  name: string;
  label?: string;
  href?: string;
  onOpen?: () => void;
}> = ({ name, label, href, onOpen }) => {
  const actionProps = {
    component: href ? 'a' : 'button',
    href,
    target: href ? '_blank' : undefined,
    rel: href ? 'noopener' : undefined,
    'aria-label': `Open ${name}'s full resume`,
    onClick: (event: React.MouseEvent) => {
      event.stopPropagation();
      onOpen?.();
    },
  } as const;

  if (label)
    return (
      <Button
        size="small"
        startIcon={<DescriptionOutlinedIcon />}
        {...actionProps}
        sx={{
          ...cardButtonSx,
          px: 0.75,
          color: 'text.link',
          '@media (hover: hover)': {
            '&:hover': { backgroundColor: 'text.linkLight' },
          },
        }}
      >
        {label}
      </Button>
    );

  return (
    <Tooltip title="Open full resume" placement="top">
      <IconButton
        size="small"
        {...actionProps}
        sx={{
          width: '1.75rem',
          height: '1.75rem',
          color: 'text.link',
          flexShrink: 0,
          '&:hover': { backgroundColor: 'text.linkLight' },
        }}
      >
        <DescriptionOutlinedIcon sx={{ fontSize: '1.25rem' }} />
      </IconButton>
    </Tooltip>
  );
};
